import {ICheckboxGroupOption} from "@pg-design/checkbox-module";

export const normalizeLeadQuestions = (allQuestions: ICheckboxGroupOption[], selectedQuestions: string[], customMessage?: string) => {
    return selectedQuestions
        .map((q) => {
            if (q === "inny" && customMessage) {
                return {
                    value: "inny",
                    label: customMessage ? "Inny temat: " + customMessage : ""
                };
            }

            return {
                value: q,
                label: allQuestions.find((option) => option.value === q)?.labelContent?.toString()
            };
        })
        .filter(({label}) => label) as {value: string; label: string}[];
};
import {ICheckboxGroupOption} from "@pg-design/checkbox-module";

export const normalizeLeadQuestions = (allQuestions: ICheckboxGroupOption[], selectedQuestions: string[], customMessage?: string) => {
    return selectedQuestions
        .map((q) => {
            if (q === "inny" && customMessage) {
                return {
                    value: "inny",
                    label: customMessage ? "Inny temat: " + customMessage : ""
                };
            }

            return {
                value: q,
                label: allQuestions.find((option) => option.value === q)?.labelContent?.toString()
            };
        })
        .filter(({label}) => label) as {value: string; label: string}[];
};
